import { useEffect, useState } from "react";
import { useParentBridge } from "../../hooks/useParentBridge";
import { Button } from "../common";
import "./preSubmission.scss";

const PreSubmission = ({ isNhsComplaint, answers, updateQuestion, previousQuestion, onReset }) => {
  const { postToParent, addHandler } = useParentBridge();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    postToParent({ type: "LOGGED_IN_CHECK" });

    const off = addHandler((msg) => {
      if (msg.type === "LOGGED_IN_CHECK_RESPONSE") {
        setIsLoggedIn(msg.isLoggedIn);
      }
    });

    return off;
  }, [addHandler, postToParent]);

  const postSubmissionToParent = (isNewUser) => {
    sessionStorage.removeItem("complaintChecker");
    isLoggedIn
      ? postToParent({
          type: "CHECKER_SUBMIT_LOGGED_IN",
          isValidComplaint: true,
          completionDateTime: Date.now(),
          isNhsComplaint: isNhsComplaint,
          isParlimentaryComplaint: !isNhsComplaint,
          isNewUser: isNewUser,
          answers: answers,
        })
      : postToParent({
          type: "CHECKER_SUBMIT",
          isValidComplaint: true,
          completionDateTime: Date.now(),
          isNhsComplaint: isNhsComplaint,
          isParlimentaryComplaint: !isNhsComplaint,
          isNewUser: isNewUser,
          answers: answers,
        });
  };

  const handleCheckAnother = () => {
    if (onReset) onReset();
  };

  const handleBack = () => {
    updateQuestion(previousQuestion);
  };

  return (
    <div className="presubmission">
      <h2 className="presubmission__title">
        It looks like your complaint is ready for us to look at.
      </h2>

      <p className="presubmission__text">
        You can now start filling in our online complaints form. Please make
        sure you upload your final response and supporting documentation.
      </p>

      <h3 className="presubmission__subtitle">We will need to know about:</h3>
      <ul className="presubmission__list">
        <li>Your complaint</li>
        <li>When it happened</li>
        <li>How it affected you</li>
        <li>What you would like done to put things right</li>
        <li>If you are planning or have taken legal action</li>
        <li>If you are complaining for someone else.</li>
      </ul>

      <p className="presubmission__text">
        Find out more about{" "}
        <a
          href="https://www.ombudsman.org.uk/making-complaint/complain-us-getting-started/filling-our-complaint-form"
          target="_blank"
          rel="noopener noreferrer"
        >
          filling in our complaint form.
        </a>
      </p>

      <h3 className="presubmission__section-title">Create a new complaint</h3>

      <p className="presubmission__text">
        If you already have an account with us, please login below to create a
        new complaint or continue with an existing one. If you are new to our
        service, please create a new account.
      </p>

      <p className="presubmission__text">
        You can also{" "}
        <a
          href="https://www.ombudsman.org.uk/making-complaint/information-advocates-and-representatives/complaint-forms"
          target="_blank"
          rel="noopener noreferrer"
        >
          download a complaint form
        </a>{" "}
        from our website and email your completed form to us at{" "}
        <a
          href="mailto:phso.enquiries@ombudsman.org.uk"
          target="_blank"
          rel="noopener noreferrer"
        >
          phso.enquiries@ombudsman.org.uk
        </a>
      </p>

      <div className="presubmission__divider" />

      {isLoggedIn != null && (
        <div className="presubmission__actions">
          {isLoggedIn ? (
            <>
              <Button variant="previous" onClick={handleCheckAnother}>
                Check another complaint
              </Button>
              <Button
                variant="continuation"
                onClick={() => {
                  postSubmissionToParent(false);
                }}
              >
                Continue complaint
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="previous"
                onClick={() => postSubmissionToParent(true)}
              >
                Create account
              </Button>
              <Button
                variant="continuation"
                onClick={() => postSubmissionToParent(false)}
              >
                Log in
              </Button>
            </>
          )}
        </div>
      )}

      <div className="presubmission__divider" />

      <div className="presubmission__back">
        <Button variant="cancel" onClick={handleBack}>
          Back
        </Button>
      </div>
    </div>
  );
};

export default PreSubmission;
